import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import logo from '../../img/medel-logo.svg';
import backIcon from '../../img/ic_arrow_back.svg';

function Header({
  sessionStore: { affectedEar = null, hearingLossType = null },
  showBackButton,
  onClick: backClick,
  awareNote,
  currentQuestion,
  maxQuestion,
}) {
  const { t } = useTranslation();
  let questionsClass = 'header-answers';
  if (awareNote) {
    questionsClass += ' aware-note';
  }

  const currentProgress = (currentQuestion / maxQuestion) * 100;

  return (
    <>
      <header className="container-fluid header-nav">
        <div className="container d-flex p-0 justify-content-between">
          <div className="d-flex justify-content-start">
            {showBackButton && (
              <nav>
                <ul>
                  <li>
                    <button type="button" onClick={backClick} className="btn-img">
                      <img
                        className="img-fluid"
                        alt={t('common.back')}
                        title={t('common.back')}
                        src={backIcon}
                      />
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <div>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-img"
            >
              <img src={logo} className="logo img-fluid" alt="MED-EL Logo" />
            </button>
          </div>
        </div>
      </header>
      <div className={awareNote ? 'container-fluid p-0' : 'container p-0'}>
        <div
          className="progress-bar"
          style={{ width: `${currentProgress}%` }}
          aria-valuenow={currentProgress}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
      <div className={questionsClass}>
        <div className="container d-flex justify-content-end p-0">
          {affectedEar && <span className="ear">{affectedEar}</span>}
          {hearingLossType && <span>{hearingLossType}</span>}
        </div>
      </div>
    </>
  );
}

Header.propTypes = {
  sessionStore: PropTypes.objectOf(PropTypes.any).isRequired,
  showBackButton: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  awareNote: PropTypes.bool,
  currentQuestion: PropTypes.number.isRequired,
  maxQuestion: PropTypes.number.isRequired,
};

Header.defaultProps = {
  awareNote: false,
};

export default Header;
